import React, { useState, useEffect, useMemo, useRef } from 'react';
import Paymentform from '../CommonComponents/Paymentform'
import { Services } from '../../network/Services';
import SearchBar from '../CommonComponents/SearchBar';
import AddNewUser from '../AddNewUser';
import { demo, formatDateIntoDDMMYY, formatDateIntoIndia, getDateFormatted, getTodayDateUSFormat, isNotValidNullUndefile, isNotValidNullUndefileInstallmentAmount, isNullUndefine, limitPercentage, lplSubtinent, removeCommas } from '../../control/Constant';
import { isValidFuntion, formatName, formatDateLocal, formatDateLocalPST,formatDateIntoUS} from '../../control/Constant';
import config from '../../config.json'
import AddStaff from '../AddStaff';
import OriginatingSelect from '../CustomSelect';
import SearchableSelect from '../CustomSelect';
import { sortedArray } from '../../network/helper';
import { useNavigate } from 'react-router-dom';
import OtherInput from '../OtherInput';
import { useConfirm } from '../ConfirmationToaster';


const LifepointLaw = ({ paymentData, setPaymentData, attorneys, setSelectedUserData, setuseLoader, setToast, isHourlyIOALTA, subtinentId, installmentpay, setInstallmentpay, installmentAmount, setInstallmentamount, resetToCompanySelection, PaymentOption, setPaymentoption, handleScroll, resetToLifepaointdata, timeMatter, setTimematter, paymentAccount, setPaymentaccount, isUpdated, userRegistration, queryData, setPayLatter, setSelectedCompany, splitCards,splitPaymentno  , finalIntallmentMethod, userAuthSubIdState,trxnStatus,setIsSplitpaymentsession, queryData22,setSplitcards,setSplitPaymentno,setRecurringCard,setScheculeCard,otherSourceref,addnewService,setAddnewservice,scrollToSection,servicetyperef}) => {
  const [matterNumber, setMatterNumber] = useState("");
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [service, setService] = useState()
  const confirm = useConfirm();
  const [selectedUser, setSelecteduser] = useState('')
  const [showUserForm, setshowUserForm] = useState(false)
  const [originating, setOriginating] = useState()
  const [reponsible, setReponsible] = useState()
  const [isServiceLocked, setIsServiceLocked] = useState(false);
  let userRegistred = JSON.parse(sessionStorage.getItem('userRegistred'));
  let isClient = JSON.parse(sessionStorage.getItem('isClient'));
  const [showConfirm, setShowConfirm] = useState(false);
  const toNumber = (value) => isNotValidNullUndefile(value) ? Number(String(value)?.replace(/[^\d.-]/g, "")) : "";
  let confirmResolveRef = useRef(null);
  const notifyTypearray = [
    { label: 'Weekly', value: 7 },
    { label: 'Monthly', value: 1 },
    { label: 'Quarterly', value: 3 },
    { label: 'Half-yearly', value: 6 },
    { label: 'Yearly', value: 12 },
  ];
  const serviceHead = ['Service Name', 'Due Date', 'Total Amount', 'Total Discount', 'Total Paid', 'Pending Amount', 'Refund Amount', 'Action', 'Matter Status']
  const serviceHead2 = ['Total Amount', 'Initial Amount', 'Installment Amount', 'Installment Frequencies', 'Installment Date']
  const [issplitPayment, setIssplitPayment] = useState(false);
  const [splitsessiondata, setSplitsessiondata] = useState(0);
  const navigate = useNavigate();
  const [sourceType,setSourcetype] = useState([])
  const[clikedOnPay,setClikedOnPay]=useState(false)


  useEffect(() => {
    let sessionSubtenantId = sessionStorage.getItem('SubtenantId');
    let SessPrimaryUserId = sessionStorage.getItem('SessPrimaryUserId');
    let isOtpVarified = JSON.parse(sessionStorage.getItem('isOtpVarified'));
    let userRegistred = JSON.parse(sessionStorage.getItem('userRegistred'));
    let issplitPayment = sessionStorage.getItem('userDeatils') ? JSON.parse(sessionStorage.getItem('userDeatils'))?.splitPayment : false;
    let sessionUserData = sessionStorage.getItem('userDeatils') ? JSON.parse(sessionStorage.getItem('userDeatils')) : false;
    setIssplitPayment(issplitPayment)
    if (isOtpVarified == true || userRegistred == true || issplitPayment == true || queryData?.paymnetFromIntake === "true" || queryData?.paymnetFromEventCoordinator == 'true') {
    if (queryData?.paymnetFromIntake === "true" || queryData?.paymnetFromEventCoordinator == 'true') {
      SessPrimaryUserId = queryData?.clientParaData?.memberId || queryData?.UserId;
      sessionSubtenantId = queryData?.clientParaData?.subtenantId || queryData?.subtenantId;
    }
    if (isOtpVarified == true || userRegistred == true || queryData?.paymnetFromIntake === "true" || issplitPayment == true || queryData?.paymnetFromEventCoordinator == 'true') {
      let inputData = {
        pageNumber: 1,
        rowsOfPage: 40,
        searchingText:null,
        subtenantId: sessionSubtenantId,
      };

      fetchUserData(inputData, (issplitPayment == true ? sessionUserData?.userId : SessPrimaryUserId))
    }
   }
  }, [isUpdated, userRegistred])

  useEffect(()=>{
    if(queryData?.paymnetFromEventCoordinator !== 'true'){
      let originatingselect = originating?.filter((e) => { return demo == false ? e?.userId =='9e6ea069-3eff-429a-8ffd-6a082f1c72b3' : e?.userId == 'a939b7a5-c28a-4fc8-b6ae-7a76681662b7' })[0]?.userId
      let reponsibleselect = reponsible?.filter((e) => { return demo == false ? e?.userId == '9e6ea069-3eff-429a-8ffd-6a082f1c72b3' : e?.userId == 'a939b7a5-c28a-4fc8-b6ae-7a76681662b7' })[0]?.userId
      setPaymentData((prev)=>{return {...prev,originatingAttorney:originatingselect,responsibleAttorney:reponsibleselect}})
    }
  },[originating,reponsible])

  useEffect(()=>{
      // let issplitPayment = sessionStorage.getItem('userDeatils') ? JSON.parse(sessionStorage.getItem('userDeatils'))?.splitPayment : false;
      let sessionUserData = sessionStorage.getItem('userDeatils') ? JSON.parse(sessionStorage.getItem('userDeatils')) : false;
      setSplitsessiondata(sessionUserData)
      if(issplitPayment == true){
      let currentOrder = selectedUser?.clientAuthSubsVMs?.filter((ele) => ele?.userAuthSubId == sessionUserData?.userAuthSubId)[0];
      let currentOrderItem = currentOrder?.clientAuthInsVMs?.filter((ele) => ele?.authInsId == sessionUserData?.authInsId);
      console.log(sessionUserData,"sessionUserDatacurrentOrder1",currentOrderItem,currentOrder,'selectedUser',selectedUser)
      if(trxnStatus == 'CANCELLED' || trxnStatus == 'FAILED'){
        let currecntCardamount = splitCards?.find((e)=> e.id == (JSON.parse(sessionStorage.getItem('userDeatils'))?.splitCardnumber))?.amount
              console.log(sessionUserData,"sessionUserDataisInstallmentPayment",currecntCardamount,'splitCards',splitCards)

        if(sessionUserData?.isInstallmentPayment == true){
          setInstallmentpay(1)
          setPaymentoption(2)
        }
        // setSplitPaymentno('Yes')
        // alert(1)
        // setRecurringCard(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCard)
        payServicefunc(currentOrder, currecntCardamount, sessionUserData?.isInstallmentPayment)
        return
      }

      if(currentOrderItem?.length > 0){
      let splitAmount = currentOrderItem?.reduce((a,c)=> Number(a)+Number(c.payAmount),0);
      let tAmount = sessionUserData?.isInstallmentPayment == true ? Number(sessionUserData?.payAmount)?.toFixed(2) : currentOrder?.totalAmount?.toFixed(2)
      // console.log(tAmount,"tAmount", splitAmount?.toFixed(2),"currentOrder",currentOrder,"sessionUserData",sessionUserData)
      if(tAmount == splitAmount?.toFixed(2)){
        // alert('Done')
        // alert("Full payment already done");
        let queryData = JSON?.parse(sessionStorage.getItem('queryData'))
        console.log(queryData,"queryDatadone")
        if(queryData?.paymnetFromIntake == 'true'){
          setToast({ message: 'Split payment completed successfully.', type: 'success' });
          return;
        }
        setToast({ message: 'Split payment completed successfully.', type: 'success' });
        setSplitPaymentno('No')
        // Clean up split payment session data without resetting company selection
        // resetToCompanySelection()
        sessionStorage.removeItem('userDeatils');
        sessionStorage.removeItem('userRegistred');
        sessionStorage.removeItem('SessPrimaryUserId');
        sessionStorage.removeItem('recursionData');
        setIsSplitpaymentsession(false)
        setTimeout(()=>{
        setSplitcards([{id:1,amount:0}]);
        setRecurringCard('')
        setPaymentoption(1)
        },4000)
        // Stay on the payment page instead of navigating to company selection
        // navigate('/')
        return;
      }
      const isJSON = (s) => { try { JSON.parse(s); return true } catch { return false } };
      const raw = sessionStorage.getItem("userDeatils");
      const user = isJSON(raw) ? JSON.parse(raw) : {};
      const split = user?.splitCards;
      const cards = isJSON(split) ? JSON.parse(split) : [];


      let currecntCardamount = (splitCards?.length == 1 ? cards : splitCards)?.find((e)=> e.id == (JSON.parse(sessionStorage.getItem('userDeatils'))?.splitCardnumber + 1))?.amount
      if(trxnStatus == 'CANCELLED'){
          currecntCardamount = splitCards?.find((e)=> e.id == (JSON.parse(sessionStorage.getItem('userDeatils'))?.splitCardnumber))?.amount
      }
      console.log(sessionUserData,"sessionUserDataisInstallmentPayment",currecntCardamount,'splitCards',splitCards)
      if(sessionUserData?.isInstallmentPayment == true){
        setInstallmentpay(1)
        setPaymentoption(2)
        payServicefunc(currentOrder, currecntCardamount, sessionUserData?.isInstallmentPayment)
        return;
      }
      payServicefunc(currentOrder, currecntCardamount)
      }
      }
  },[selectedUser,issplitPayment])


  useEffect(() => {
    if (queryData?.refrencePage === "AMA_ADVANCE") {
      if (!Array.isArray(service) || service?.length === 0) return;
      let orderDetailsParsed = {};
      if (typeof queryData?.OrderDetails === "string") {
        try { orderDetailsParsed = JSON.parse(queryData.OrderDetails); } catch (e) { }
      }
      const advanceAmount = orderDetailsParsed?.SubscriptionAmt;
      if (isNullUndefine(advanceAmount)) return;
      const amaService = service?.find((s) => s.subscriptionId === 1);
      const subsDetailsData = Array.isArray(queryData?.subsDetails) ? queryData?.subsDetails?.[0] : queryData?.subsDetails;
      const formatAmount = (num) => {
        if (!num) return "";
        num = parseFloat(String(num).replace(/,/g, ""));
        return isNaN(num) ? "" : num.toLocaleString("en-US", { minimumFractionDigits: 2 });
      };
      setPaymentData((prev) => {
        const updated = {
          ...prev,
          lineOfBusiness: 1,
          subscriptionName: amaService?.subscriptionName?.trim() || "Annual Maintenance Agreement - Advance Payment",
          responsibleAttorney: subsDetailsData?.attorneyId || "",
          originatingAttorney: subsDetailsData?.originatingAttorneyId || "",
          payAmount: formatAmount(advanceAmount),
          amount: formatAmount(advanceAmount),
        };
        if (JSON.stringify(prev) === JSON.stringify(updated)) return prev;
        return updated;
      });
      setIsServiceLocked(true);
      return;
    }
    const subsArray = queryData?.subsDetails;
    const subsDetailsData = Array.isArray(subsArray) ? subsArray[0] : subsArray;
    const hasValidSubsDetails = subsDetailsData
      && !(Object.keys(subsDetailsData)?.length === 1 && subsDetailsData.subscriptionId === 1);
    const hasNewUserValidSubsDetails = subsDetailsData ? Object.keys(subsDetailsData)?.length > 0 : false;
    const subsDetails = (hasValidSubsDetails || hasNewUserValidSubsDetails)
      ? subsDetailsData
      : queryData?.clientOrderDetails?.productList?.[0];
    const isFromIntake = queryData?.paymnetFromIntake === "true";
    if (!isFromIntake || !Array.isArray(service) || service?.length === 0 || !subsDetails) return;
    const validIds = [1, 2, 4, 5];
    const subId = subsDetails.subscriptionId || subsDetails.productId;
    if (!validIds.includes(subId)) return;
    const selectedService = service?.find((s) => s.subscriptionId === subId);
    if (!selectedService) return;
    let finalPayAmount = queryData?.clientOrderDetails?.totalCost;
    const subs = queryData?.subsDetails?.[0];
    const missed = subs?.missedRenewals ? JSON.parse(subs.missedRenewals) : null;
    if (missed && missed.paymentSchedule === "Later" && missed.number === "0") {
      finalPayAmount = subs?.totalAmount;
    }
    if (isNullUndefine(finalPayAmount) && missed && missed.paymentSchedule === "Now" && missed.amaTypes !== "Portal") {
      finalPayAmount = Number(missed.amount || 0) * Number(missed.number || 1);
    }
    if (queryData22) {
      const subs22 = queryData22?.subsDetails?.[0];
      if (missed && missed.paymentSchedule === "Now" && missed.amaTypes === "Portal") {
        const baseAmount = Number(missed.amount || 0);
        const count = Number(missed.number || 0);
        const portalAmount = subs22?.totalAmount
          ? Number(subs22?.totalAmount)
          : 1500;
        finalPayAmount = baseAmount * count + portalAmount;
      }
    }
    if (isNullUndefine(finalPayAmount)) {
      finalPayAmount = subs?.totalAmount;
    }
    const formatAmount = (num) => { if (!num) return ""; num = parseFloat(String(num).replace(/,/g, "")); return isNaN(num) ? "" : num.toLocaleString("en-US", { minimumFractionDigits: 2 }); };
    setPaymentData((prev) => {
      const updated = {
        ...prev,
        lineOfBusiness: subsDetailsData.subscriptionId === 1 ? 1 : selectedService.subscriptionId,
        subscriptionName: (hasValidSubsDetails || hasNewUserValidSubsDetails)
          ? selectedService?.subscriptionName?.trim() || ""
          : subsDetails?.productName?.trim() || "",
        responsibleAttorney: subsDetails.attorneyId || "",
        originatingAttorney: subsDetails.originatingAttorneyId || "",
        payAmount: hasNewUserValidSubsDetails ? formatAmount(finalPayAmount ? finalPayAmount : queryData?.clientOrderDetails?.totalCost) : hasValidSubsDetails ? formatAmount(queryData?.clientOrderDetails?.paidAmt) : formatAmount(subsDetails.totalAmount || subsDetails.paidProductPrice || subsDetails.productPrice),
        amount: hasNewUserValidSubsDetails ? formatAmount(finalPayAmount ? finalPayAmount : queryData?.clientOrderDetails?.paidAmt) : hasValidSubsDetails ? formatAmount(queryData?.clientOrderDetails?.paidAmt) : formatAmount(subsDetails.totalAmount || subsDetails.paidProductPrice || subsDetails.productPrice),
        // paymentMethod:"credit"
      };
      if (JSON.stringify(prev) === JSON.stringify(updated)) return prev;
      return updated;
    });
    setIsServiceLocked(true);
  }, [queryData?.subsDetails, queryData?.clientOrderDetails, queryData?.paymnetFromIntake, service, paymentData,queryData?.paymnetFromEventCoordinator]);

  const fetchUserData = (json, id) => {
      const isJSON = (s) => { try { JSON.parse(s); return true } catch { return false } };
      const raw = sessionStorage.getItem("userDeatils");
      const user = isJSON(raw) ? JSON.parse(raw) : {};
    setuseLoader(true)
    Services?.GetClientDetailsByUserId(json, id).then((res) => {
      setSearchData(res.data?.data[0])
      const { memberId, memberName, primaryEmailAddress, primaryPhoneNumber, loginUserId } = res.data?.data[0]
      const clientAuthSubs = res.data?.data[0]?.clientAuthSubsVMs?.[0];
      const sessionPaymentMethod = sessionStorage.getItem("PaymentMethod");
      const storedUserAuthSubId = sessionStorage.getItem("userAuthSubId");
      const clientAuthIns = clientAuthSubs?.clientAuthInsVMs?.[0];
      const userAuthSubId = userAuthSubIdState ? userAuthSubIdState : storedUserAuthSubId;
      const paymentType = finalIntallmentMethod || sessionPaymentMethod;
      if (userAuthSubId || paymentType) {
        const sessionObj = {
          userAuthSubId,
          paymentMethod: paymentType,
        };
        if(user.splitCardnumber == user.recurringCardAMA){
        sessionStorage.setItem("userPaymentTypeandAuth", JSON.stringify(sessionObj));
        }
      }
      setSelectedUserData((prev) => ({
        ...prev,
        userId: memberId,
        fullName: memberName,
        primaryEmail: primaryEmailAddress,
        primaryMobile: primaryPhoneNumber,
        memberId: memberId,
        loginUserId: loginUserId,
        userAuthSubId:userAuthSubId
      }))
      setuseLoader(false)
    })
      .catch((err) => {
        setuseLoader(false)
        console.error(err);
      });
  };
  useEffect(() => {
    setSelecteduser(() => ({
      fullName: '',
      primaryEmail: '',
      primaryMobile: '',
      memberId: '',
      matNo: '',
      contactStatus: ''
    }));
    setMatterNumber('')
  }, [timeMatter])

  useEffect(() => {
    if (PaymentOption == 1) {
      setInstallmentpay('')
      setPaymentData((prev) => {
        return {
          ...prev,
          // payAmount: '',
          // installmentFrequencies: 1,
          // installmentDate: '',
          // installmentNumber: '',
          // authUnit: 'months'
        }
      })
      // setInstallmentamount(0)
    }
    if (PaymentOption == 2) {
      setInstallmentpay(2)
    }
  }, [PaymentOption])

  const runApis = (data, id) => {
    // if (!matterNumber?.trim() && !data?.trim()) return;
    if (!data?.trim()) return;
    let inputData = {
      pageNumber: 1,
      rowsOfPage: 40,
      searchingText: data || null,
      subtenantId: subtinentId || id,
      isTimeMatterClient: null
    };
    setuseLoader(true)
    setClikedOnPay(false)
    Services?.getUserByName(inputData).then((res) => {
      if (res?.data) {
        setResults(res.data?.data || []);
        setShowDropdown(true);
        setuseLoader(false)
        if (res?.data?.data?.length == 0) {
          setshowUserForm(true)
          setSelecteduser(() => ({
            fullName: '',
            primaryEmail: '',
            primaryMobile: '',
            memberId: '',
            matNo: '',
            contactStatus: ''
          }));
          setSelectedUserData()
        }
      }
    })
      .catch((error) => {
        setResults([]);
        setshowUserForm(true)
        setShowDropdown(false);
        setuseLoader(false)
      });
  }

  function formatToUS(value) {
    // console.log(value,"valuevaluevaluevaluevalue")
    if (!value) return "";
    let cleaned = value?.replace(/,/g, "");

    if (!/^\d*\.?\d{0,2}$/.test(cleaned)) {
      return null;
    }

    const parts = cleaned.split(".");
    let integerPart = parts[0];
    const decimalPart = parts[1] !== undefined ? parts[1] : null;

    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (decimalPart === null) {
      return integerPart;
    } else {
      return integerPart + "." + decimalPart;
    }
  }


  const handleInputChange = (field, e) => {
    if (field == "lineOfBusiness") {
      const value = e
      const selectedName = service?.find((s)=>{return s?.subscriptionId == e})?.subscriptionName;
      setPaymentData(prev => ({
        ...prev,
        lineOfBusiness: value,
        'serviceName': selectedName
      }));
    }else if((field == 'amount') && isNotValidNullUndefile(e)){
      if( PaymentOption == 1){
        if(splitPaymentno == 'Yes'){
      setSplitcards((prev) => [{id: 1,amount:toNumber(e),accounts: [{AccountTypeId: 1,Amount: toNumber(e)}]}]);

        }else{
          setPaymentaccount((prev) => {
            const index = prev.findIndex(item => item.AccountTypeId === 1);
            if (index !== -1) {
              const updated = [...prev];
              updated[index] = { ...updated[index], Amount: toNumber(e) };
              return updated;
            }
            return [...prev, { AccountTypeId: 1, Amount: toNumber(e) }];
          });
        }
      }
      setPaymentData({
        ...paymentData,
        [field]: e
      });
    }else{
      if (field == 'payAmount') {
        if (e == 0 || e == null || e == undefined || e == null || e == '') {
          if (e === 0 || e == '0') {
            setPaymentData((prev) => ({
              ...prev,
              paymentMethod: '',
              [field]: e, 'installmentNumber': field == 'installmentFrequencies' && e == 4 ? 1 : field == 'installmentNumber' ? e : paymentData?.installmentNumber,
              'authUnit': field == 'installmentFrequencies' ? (e == 7 ? 'days' : 'months') : paymentData?.authUnit
            }));
            return;
        }
        setInstallmentpay(2)
      } else {
        setPaymentaccount([{AccountTypeId:1,Amount:e}])
        setInstallmentpay(1)
      }
    }
    if(field == 'amount' && PaymentOption == 1){
      setPaymentaccount([{AccountTypeId:1,Amount:e}])
    }

    setPaymentData({
      ...paymentData,
      [field]: e, 'installmentNumber': field == 'installmentFrequencies' && e == 4 ? 1 : field == 'installmentNumber' ? e : paymentData?.installmentNumber,
      'authUnit': field == 'installmentFrequencies' ? (e == 7 ? 'days' : 'months') : paymentData?.authUnit
    });
  }

};

const updateUser = (data, formJson, timeMatter) => {
  const { createdBy, emailId, firstName, lastName, userId, contactStatus } = data?.data?.data
  let inputData = {
    fName: firstName,
    lName: lastName ?? '',
    mName: "",
    isPrimaryMember: true,
    subtenantId: subtinentId,
    updatedBy: createdBy,
    userId: userId,
    memberRelationship: null,
    matNo: formJson?.matno,
    contactStatus: contactStatus
  }

  const updateUser = Services?.upateMemberByuserID(inputData)
  updateUser.then((res) => {
    get_UserData(emailId, timeMatter)
    sessionStorage.removeItem('userRegistration');
    sessionStorage.setItem("userRegistred", true);
    sessionStorage.setItem("SessPrimaryUserId", userId);
  }).catch((err) => {
    console.log(err, "err")
  })
}

const get_UserData = (matterNumber, timeMatter) => {
  let inputData = {
    pageNumber: 1,
    rowsOfPage: 40,
    searchingText: matterNumber || null,
    subtenantId: subtinentId,
    isTimeMatterClient: null
  };
  setuseLoader(true)
  Services?.getUserByName(inputData).then((res) => {
    if (res?.data) {
      setResults(res.data?.data || []);
      setSearchData(res.data?.data[0])
      setuseLoader(false)
    }
  })
    .catch((error) => {
      setResults([]);
      setShowDropdown(false);
      setuseLoader(false)
    });
}

useEffect(() => {
  let defaultId = demo == false ? '9e6ea069-3eff-429a-8ffd-6a082f1c72b3' : 'a939b7a5-c28a-4fc8-b6ae-7a76681662b7'
  getServices()
  getUserListData()
  if(queryData?.paymnetFromEventCoordinator !== 'true'){
    setPaymentData((prev) => { return { ...prev, 'installmentFrequencies': 1, 'authUnit': 'months',originatingAttorney:defaultId,responsibleAttorney:defaultId } })
  }
  getServicetype()
  setClikedOnPay(false)
}, [])

const getUserListData = () => {
  const staff = {
    "subtenantId": subtinentId,
    // "isActive": true,
    "userType": "STAFF",
  }

  const attorney = {
    "subtenantId": lplSubtinent,
    "subtenantId": subtinentId,
    // "isActive": true,
    "userType": "ATTORNEY",
  }

  getUserwithType(staff, setOriginating)
  getUserwithType(attorney, setReponsible)
}


const getUserwithType = (json, setState) => {
  setuseLoader(true)
  const getUserListByRoleIdservice = Services.getUserListByRoleIdservice(json)
  getUserListByRoleIdservice.then((res) => {
    if (json.userType == 'STAFF') {
      const filterData = res?.data?.data
      // ?.filter((ele) => ele?.roleId !== 13)
      setState(filterData)
    } else {
      setState(res.data.data)
    }
    setuseLoader(false)
  }).catch((err) => {
    setuseLoader(false)
  })
}

const getServices = () => {
  setuseLoader(true)
  const result = Services?.getUserServices(subtinentId).then((res) => {
    if (res) {
      let filteredData = res?.data?.data?.sort((a, b) => {
        if (a.subscriptionId == 9) return 1;
        if (b.subscriptionId == 9) return -1;
        return 0;
      });
      setService(filteredData)
      setuseLoader(false)
    }
  }).catch((err) => {
    setuseLoader(false)
  })
}

const getServicetype = () => {
  setuseLoader(true)
  const getServicetypeparams = Services.getSourceTypeService()
  getServicetypeparams.then((res) => {
    console.log(res,"resresresgetServicetype")
    if(res?.data?.data?.length > 0){
      setSourcetype(res?.data?.data)
    }
    setuseLoader(false)
  }).catch((err) => {
    setuseLoader(false)
  })
}

const isAMAService = paymentData.lineOfBusiness === 'ama';

useEffect(() => {
  if (isNotValidNullUndefile(selectedUser?.userId)) {
    // resetToLifepaointdata()
    getUserLegalStafffuc(selectedUser?.userId)
  }
}, [selectedUser?.userId])

const getUserLegalStafffuc = (userId) => {
  const getUserLegalStaffpromise = Services.getUserLegalStaff(userId);
  getUserLegalStaffpromise.then((res) => {
    let originating = res.data.data[0].currentLegalStaff?.filter((e) => { return e.staffTypeId == 4 })
    let responsible = res.data.data[0].currentLegalStaff?.filter((e) => { return e.staffTypeId == 1 })
    let defaultId = demo == false ? '9e6ea069-3eff-429a-8ffd-6a082f1c72b3' : 'a939b7a5-c28a-4fc8-b6ae-7a76681662b7'
    if(issplitPayment != true && queryData?.paymnetFromEventCoordinator !== 'true'){
    setPaymentData((prev) => ({ ...prev, originatingAttorney: originating[0]?.legalUserId == undefined ? defaultId : originating[0]?.legalUserId, responsibleAttorney: responsible[0]?.legalUserId == undefined ? defaultId : responsible[0]?.legalUserId}))
    }
    setMatterNumber('')

  }).catch((err) => {
  })
}

const setSearchData = (data) => {
  const { memberName, primaryPhoneNumber, primaryEmailAddress, matNo, memberId, clientAuthSubsVMs, loginUserId, contactStatus, registeredOn, primaryUserMemberId,isUserActive } = data
  const matterNumberValue = !isNotValidNullUndefile(matNo)
    ? `${new Date(registeredOn).getFullYear().toString()?.slice(-2)}-${primaryUserMemberId}`
    : matNo;
  setSelecteduser((prev) => ({
    ...prev,
    userId: memberId,
    fullName: memberName,
    primaryEmail: primaryEmailAddress,
    primaryMobile: primaryPhoneNumber,
    memberId: memberId,
    clientAuthSubsVMs: clientAuthSubsVMs,
    matNo: matNo,
    loginUserId: loginUserId,
    contactStatus: contactStatus,
    isUserActive: isUserActive
  }));
  setSelectedUserData((prev) => ({
    ...prev,
    userId: memberId,
    fullName: memberName,
    primaryEmail: primaryEmailAddress,
    primaryMobile: primaryPhoneNumber,
    memberId: memberId,
    loginUserId: loginUserId,

  }))
  setshowUserForm(true)
  setMatterNumber(data.matNo); // Adjust based on your data
  setShowDropdown(false);
  if (queryData?.paymnetFromEventCoordinator !== 'true') {
    setPaymentData({
      ...paymentData,
      ['serviceMatNo']: data?.matNoe
    });
    resetToLifepaointdata()
  }
}

const headerStyle = {
  borderBottom: "1px solid #E5E7EB",
  // paddingLeft: "5px",
  backgroundColor: "#FAFBFF", // optional: improves visual clarity
  fontWeight: 500,         // optional: adds emphasis
  color: "#1A1B1C",
  // borderRight:'3px dotted grey',
  // borderWidth: '5px dotted grey',
  fontFamily: 'Roboto',
  // marginLeft:'2px',
  verticalAlign: "middle",
  padding: "6px",
  textAlign: 'start'
};

const headerStyleTop = {
  borderBottom: "1px solid #E5E7EB",
  // paddingLeft: "5px",
  backgroundColor: "#FAFBFF", // optional: improves visual clarity
  fontWeight: 500,         // optional: adds emphasis
  color: "#1A1B1C",
  // borderRight:'3px dotted grey',
  // borderWidth: '5px dotted grey',
  fontFamily: 'Roboto',
  // marginLeft:'2px',
  verticalAlign: "top",
  padding: "6px",
  textAlign: 'start',
  // display: "flex",
  // flexDirection: "column",
};



const cellStyle = {
  padding: "6px",
  verticalAlign: "middle",
  borderBottom: "1px solid #E5E7EB",
  fontFamily: 'Roboto',
  fontWeight: 400,
  color: '#6B7280',
  // maxWidth:'120px'
};

const radioButton = (label, value, state, setState) => {
  // console.log(value,"valuevaluevaluevalue")
  return <label class="radio-label custom-radio">
    <input type="radio" name={label} value={value} checked={state == value} onChange={(e) => setState(e.target.value)} />
    {/* <div class="w-4 h-4 rounded-full border-2 border-gray-400 peer-checked:border-blue-600 peer-checked:bg-blue-600 transition"></div> */}
    <span class="ml-2 text-gray-700">{label}</span>
  </label>
}

// const chackboxButtonAccount = (label, value, data, setData) => {
//   const entry = data?.length > 0 && data?.find((item) => item.AccountTypeId === value);
//   const isChecked = !!entry;

//   const handleCheckboxChange = (e) => {
//     if (e.target.checked) {
//       setData([...data, { AccountTypeId: value, Amount: 0 }]);
//     } else {
//       setData(data?.filter((item) => item.AccountTypeId !== value));
//     }
//   };

//   const handleInputChange = (e) => {
//     const newData = data?.length > 0 && data?.map((item) =>
//       item.AccountTypeId === value ? { ...item, Amount: (e.target.value) } : item
//     );
//     let calculateTotal = newData.reduce((a, c) => Number(a) + Number(c.Amount), 0)
//     if (calculateTotal > paymentData.amount) {
//       setToast({ message: 'Please enter a valid amount.', type: 'error' });
//       return
//     }
//     setData(newData);
//   };

//   return (
//     <div className="mb-2 flex items-center space-x-3">
//       <label className="flex items-center">
//         <input
//           type="checkbox"
//           value={value}
//           checked={isChecked}
//           onChange={handleCheckboxChange}
//           className="mr-2"
//         />
//         <span>{label}</span>
//       </label>
//       {isChecked && (
//         <div className="relative w-20">
//           <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
//             <span className="text-gray-500">$</span>
//           </div>
//           <input
//             type="text"
//             value={formatToUS(entry?.Amount) || ""}
//             onChange={handleInputChange}
//             placeholder="0"
//             min="0"
//             step="1"
//             className="w-20 border border-gray-300 rounded-md px-2 py-2 pl-5"
//           />
//         </div>
//       )}
//     </div>
//   );
// };

const findFinalInstallmentPay = () => {
  // const {totalAmount,totalDiscount} = formData
  const finalAmount = (removeCommas(paymentData?.amount) - (removeCommas(paymentData?.payAmount) || 0)) / (paymentData?.installmentNumber)
  // console.log(finalAmount,"finalAmount",removeCommas(paymentData?.amount) ,"amount",paymentData.payAmount,'payamount',paymentData.installmentNumber,"installment")
  return finalAmount > 0 && finalAmount != 'Infinity' ? finalAmount : 0
}

useEffect(() => {
  setInstallmentamount(findFinalInstallmentPay())
}, [findFinalInstallmentPay()])

const deleteServicefunc = async (service) => {
  if (service?.authSubscriptionId != null && service?.isCancelSubscription != true) {
    setToast({ message: 'This service has an active scheduled subscription. Please cancel it before deleting.', type: 'error' });
    return;
  }
  const ok = await confirm(
    true,
    `Are you sure you want to delete "${service?.subscriptionName}"? This cannot be undone.`,
    "Delete Service",
    "custom",
    [
      { label: 'Yes, Delete', value: true },
      { label: 'Cancel', value: false },
    ]
  );
  if (ok !== true) return;
  const loggedUserId = sessionStorage.getItem("loggedUserId");
  setuseLoader(true);
  try {
    const { clientAuthInsVMs, ...serviceFields } = service || {};
    const res = await Services.upserUserAuthSubs({
      ...serviceFields,
      userAuthSubId: service?.userAuthSubId,
      userId: selectedUser?.userId || selectedUser?.memberId,
      isActive: false,
      isDelete: true,
      upsertedBy: loggedUserId
    });
    if (res && (res.status === 200 || res.status === 204)) {
      setSelecteduser((prev) => ({
        ...prev,
        clientAuthSubsVMs: (prev?.clientAuthSubsVMs || []).filter((d) => d?.userAuthSubId !== service?.userAuthSubId)
      }));
      setToast({ message: 'Service deleted successfully.', type: 'success' });
    } else {
      setToast({ message: 'Unable to delete the service.', type: 'error' });
    }
  } catch (err) {
    console.error(err);
    setToast({ message: 'Error occurred while deleting the service.', type: 'error' });
  }
  setuseLoader(false);
};

const payServicefunc = (service, pendingAmount, isInstallmentPayment,clkOn) => {
  console.log(service, "payServicefunc",pendingAmount,isInstallmentPayment)
  if(clkOn=="Pay"){
    setClikedOnPay(true)
  }
  if(issplitPayment == true){
  setInstallmentpay('')
  // setPaymentoption(1)
  // if(trxnStatus == 'FAILED'){
  //   setPaymentData((prev) => { return { ...prev, lineOfBusiness: Number(service.subscriptionId), userAuthSubId: service.userAuthSubId, payAmount: removeCommas(service.totalAmount?.toFixed(2)), amount: removeCommas(service.totalAmount?.toFixed(2)), serviceName: service.subscriptionName,splitAmount: pendingAmount?.toString(),paymentMethod:'credit',splitCardnumber:(JSON.parse(sessionStorage.getItem('userDeatils')))?.splitCardnumber - 1 || null,originatingAttorney:JSON.parse(sessionStorage.getItem('userDeatils'))?.originatingAttorney,responsibleAttorney:JSON.parse(sessionStorage.getItem('userDeatils'))?.responsibleAttorney,subscriptionName:service.subscriptionName } })
  //   setPaymentaccount(JSON.parse(sessionStorage.getItem('userDeatils'))?.paymentAccount)
  //   // setSplitPaymentno('Yes')
  //   handleScroll()
  //   return;
  // }
  if(trxnStatus == 'CANCELLED' || trxnStatus == 'FAILED'){
    // sessionStorage.removeItem('userDeatils');
    if(isInstallmentPayment && isInstallmentPayment == true){
      // setPaymentaccount(2)
      setTimeout(()=>{setInstallmentpay(1)},1000)
      console.log(splitsessiondata,"splitsessiondataCANCELLED")
      setPaymentData((prev) => { return { ...prev,
        lineOfBusiness: Number(service?.subscriptionId), userAuthSubId: service?.userAuthSubId,
        payAmount: removeCommas(splitsessiondata?.payAmount), amount: removeCommas(service?.totalAmount?.toFixed(2)),
        serviceName: service?.subscriptionName,splitAmount: pendingAmount?.toString(),paymentMethod:'credit',
        splitCardnumber:(JSON.parse(sessionStorage.getItem('userDeatils')))?.splitCardnumber - 1 || null,
        originatingAttorney:JSON.parse(sessionStorage.getItem('userDeatils'))?.originatingAttorney,
        responsibleAttorney:JSON.parse(sessionStorage.getItem('userDeatils'))?.responsibleAttorney,
        subscriptionName:service?.subscriptionName,
      installmentAmount:service?.installmentAmount, installmentFrequencies: splitsessiondata?.installmentFrequencies,
      installmentNumber:Number(splitsessiondata?.installmentNumber),installmentDate: formatDate(splitsessiondata?.installmentStartDate),sourceType: service?.sourceTypeId}})
      setInstallmentamount(service?.installmentAmount)
      // setRecurringCard(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCard)
      handleScroll()
      // console.log("installmentNumber12",service?.installmentNumber)
      return;
    }

    setPaymentData((prev) => { return { ...prev, lineOfBusiness: Number(service?.subscriptionId), userAuthSubId: service?.userAuthSubId, payAmount: isNotValidNullUndefile(queryData?.clientOrderDetails?.totalCost) ? removeCommas(queryData?.clientOrderDetails?.totalCost) : removeCommas(service?.totalAmount?.toFixed(2)), amount: isNotValidNullUndefile(queryData?.clientOrderDetails?.totalCost) ? removeCommas(queryData?.clientOrderDetails?.totalCost) :removeCommas(service?.totalAmount?.toFixed(2)), serviceName: service?.subscriptionName,splitAmount: pendingAmount?.toString(),paymentMethod:'credit',splitCardnumber:(JSON.parse(sessionStorage.getItem('userDeatils')))?.splitCardnumber - 1 || null,originatingAttorney:JSON.parse(sessionStorage.getItem('userDeatils'))?.originatingAttorney,responsibleAttorney:JSON.parse(sessionStorage.getItem('userDeatils'))?.responsibleAttorney,subscriptionName:service?.subscriptionName,totalDiscount:service?.totalDiscount,sourceType: service?.sourceTypeId } })
    setPaymentaccount(JSON.parse(sessionStorage.getItem('userDeatils'))?.paymentAccount)
    // setSplitcards(JSON.parse(JSON.parse(sessionStorage.getItem('userDeatils'))?.splitCards))
    // Only set split payment to Yes if we're continuing with split payment flow
    const userDetails = JSON.parse(sessionStorage.getItem('userDeatils'));
    if (userDetails && userDetails.splitPayment) {
      setSplitPaymentno('Yes')
    }
    // setInstallmentpay('')
    setScheculeCard(sessionStorage.getItem('scheduleCard') || '')
    // setInstallmentamount(service?.installmentAmount)

    return;
  }
  if(isInstallmentPayment && isInstallmentPayment == true){
    // setPaymentaccount(2)
    // setInstallmentpay(1)
    console.log(splitsessiondata,"splitsessiondata")
    setPaymentData((prev) => { return { ...prev,
      lineOfBusiness: Number(service.subscriptionId), userAuthSubId: service.userAuthSubId,
      payAmount: removeCommas(splitsessiondata?.payAmount), amount: removeCommas(service.totalAmount?.toFixed(2)),
      serviceName: service.subscriptionName,splitAmount: pendingAmount?.toString(),paymentMethod:'credit',
      splitCardnumber:(JSON.parse(sessionStorage.getItem('userDeatils')))?.splitCardnumber || null,
      originatingAttorney:JSON.parse(sessionStorage.getItem('userDeatils'))?.originatingAttorney,
      responsibleAttorney:JSON.parse(sessionStorage.getItem('userDeatils'))?.responsibleAttorney,
      subscriptionName:service.subscriptionName,
    installmentAmount:service?.installmentAmount, installmentFrequencies: splitsessiondata?.installmentFrequencies,
    installmentNumber:Number(splitsessiondata?.installmentNumber),installmentDate: formatDate(splitsessiondata.installmentStartDate),totalDiscount:service?.totalDiscount,sourceType: service?.sourceTypeId}})
    setInstallmentamount(service?.installmentAmount)
    handleScroll()
    // console.log("installmentNumber12",service?.installmentNumber)
    return;
  }
  const payAmountValue = isNotValidNullUndefile(queryData?.clientOrderDetails?.totalCost)
    ? removeCommas(queryData?.clientOrderDetails?.totalCost)
    : removeCommas((service.totalAmount - (service.totalDiscount || 0))?.toFixed(2));
  // console.log("jncnlknzxlkc", queryData?.clientOrderDetails, service, {payAmount: isNotValidNullUndefile(queryData?.clientOrderDetails?.totalCost) ? removeCommas(queryData?.clientOrderDetails?.totalCost) : removeCommas(service.totalAmount?.toFixed(2) - service.totalDiscount )})
  setPaymentData((prev) => { return { ...prev, lineOfBusiness: Number(service.subscriptionId), userAuthSubId: service.userAuthSubId, payAmount: payAmountValue, amount: payAmountValue, serviceName: service.subscriptionName,splitAmount: pendingAmount?.toString(),paymentMethod:'credit',splitCardnumber:(JSON.parse(sessionStorage.getItem('userDeatils')))?.splitCardnumber || null,originatingAttorney:JSON.parse(sessionStorage.getItem('userDeatils'))?.originatingAttorney,responsibleAttorney:JSON.parse(sessionStorage.getItem('userDeatils'))?.responsibleAttorney,subscriptionName:service.subscriptionName,totalDiscount:service?.totalDiscount,sourceType: service?.sourceTypeId } })
  setPaymentaccount(JSON.parse(sessionStorage.getItem('userDeatils'))?.paymentAccount)

  handleScroll()
  return;
  }
  setInstallmentpay('')
  // setPaymentoption(1)
  sessionStorage.setItem('isPayLatter',true)
  setPayLatter(true)
  setPaymentData((prev) => { return { ...prev, lineOfBusiness: Number(service.subscriptionId), userAuthSubId: service.userAuthSubId, payAmount: pendingAmount?.toFixed(2), amount: removeCommas(service.totalAmount?.toFixed(2)), serviceName: service.subscriptionName, totalDiscount: service?.totalDiscount,sourceType: service?.sourceTypeId} })
  otherSourceref?.current?.getOtherFrmAPI()
  setInstallmentamount(service.installmentAmount)
  setPaymentaccount([{AccountTypeId:1,Amount:pendingAmount?.toFixed(2)}])
  handleScroll()
}

const getTomorrowDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  date.setDate(date.getDate() + 1);
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, '0');
  // console.log("54trefsd",year,"-",month,"-",day)
  return `${year}-${month}-${day}`;

};

const handleInstallmentDateBlur = (e) => {
  const value = e.target.value;
  if (value?.length !== 10) return;
  const enteredDate = new Date(value);
  const minDate = new Date(getTomorrowDate());
  if (enteredDate < minDate) {
    setToast({ message: 'Please enter date from tomorrow onward.', type: 'error' });
    setPaymentData((prev) => ({ ...prev, installmentDate: '' }));
  }
};



function parseAndFormatAmount(value) {
  console.log("fdghfhdgfsd",value)
  const strValue = String(value || "").replace(/,/g, ""); // Remove existing commas
  const number = parseFloat(strValue);
  if (isNaN(number)) return "";

  return number.toLocaleString("en-US");
}

const returnStartDate99 = (authUnit, authLength, payAmountDate, index, clientAuthInsVMs) => {
  let getPAMt=payAmountDate
  const checkDTformat=payAmountDate?.includes("T")
  if(checkDTformat==true){
    getPAMt=getPAMt.split("T")[0]
  }
  // const [year, month, day] = payAmountDate.split("-")?.map(Number); // OLD
    const [year, month, day] = getPAMt?.split("-")?.map(Number); // Modified
    const startDate = new Date(year, month - 1, day);
    const length = parseInt(authLength);

  //inst. freq=weekly then authUnit=="days",else authUnit ="months"
  if (authUnit === "days") {
    // Add (length * index) days
    // console.log("3gfwed","----",startDate.getTime() + length * 24 * 60 * 60 * 1000 * index,"------complete",new Date(startDate.getTime() + length * 24 * 60 * 60 * 1000 * index))
    return new Date(startDate.getTime() + length * 24 * 60 * 60 * 1000 * index);
  }

  if (authUnit === "months") {
    const updatedDate = new Date(startDate);
    if (length === 12) {
      updatedDate.setFullYear(updatedDate.getFullYear() + 1 * index);
    } else if (length < 12) {
      const originalDay = updatedDate.getDate();
      updatedDate.setMonth(updatedDate.getMonth() + (authLength) * index);

      // Fix case where months don't have the original day (e.g., Feb 31 → Mar 2)
      if (updatedDate.getDate() < originalDay) {
        updatedDate.setDate(0); // last day of previous month
      }
    }
    return clientAuthInsVMs?.length == 0 ? new Date(startDate.getTime()) : updatedDate;
  }

}

const installmentTabledata = useMemo(() => { // pay,ent page installemt
  let resultArr = Array.from({ length: paymentData?.installmentNumber || 0 }, (_, index) => ({
    amount: paymentData?.amount,
    payAmount: paymentData?.payAmount,
    installmentAmount: installmentAmount,
    installmentFrequencies: paymentData?.installmentFrequencies,
    installmentDate: returnStartDate99(paymentData?.authUnit, paymentData?.installmentFrequencies, paymentData?.installmentDate, index)
  }));

  return resultArr
}, [paymentData?.installmentNumber, paymentData, installmentAmount])

const [isOpen, setIsOpen] = useState(false);

useEffect(() => {
  if (isOpen) {
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden"; // html
  } else {
    document.body.style.overflow = "auto";
    document.documentElement.style.overflow = "auto";
  }
  return () => {
    document.body.style.overflow = "auto";
    document.documentElement.style.overflow = "auto";
  };
}, [isOpen]);
// console.log(paymentData,paymentData?.installmentNumber,"installmentNumber12",PaymentOption)

const formatDate = (dateString) => {
  if (!dateString) return "";
  return dateString.split("T")[0];
};

  const handleBeforeOpen = () => {
    return new Promise((resolve) => {
      if (window.isEditClicked) {
        confirmResolveRef.current = resolve;
        setShowConfirm(true);
      } else {
        resolve(true);
      }
      if (window.isViewOnlyMode && window.isViewOnlyMode()) {
        resolve(true);
        return;
      }
      const details = window.getUserDetails ? window.getUserDetails() : {};
      const isEmpty = Object.values(details).every(
        (val) => val === "" || val === null || val === undefined
      );
      if (isEmpty) {
        resolve(true);
        return;
      }
      if (typeof window.setEditClickGlobal === "function") {
        confirmResolveRef.current = resolve;
        setShowConfirm(true);
      } else {
        resolve(true);
      }
    });
  };

  const handleSave = () => {
    if (typeof window.isEditClicked !== "undefined" && !window.isEditClicked) {
      if (typeof window.addUserGlobal === "function") {
        window.addUserGlobal();
      }
    } else {
      if (typeof window.handleSaveGlobal === "function") {
        window.handleSaveGlobal();
      }
    }
    confirmResolveRef.current(false);
    setShowConfirm(false);
  };

  const handleDiscard = () => {
    if (typeof window.handleCancelGlobal === "function") {
      window.handleCancelGlobal();
    }
    confirmResolveRef.current(false);
    setShowConfirm(false);
  };

  const queryDataSubdetails = useMemo(()=> queryData?.subsDetails?.[0],[queryData?.subsDetails?.length]);
  const lengthInstallment = useMemo(()=>{
  const futurePayDate = new Date(queryDataSubdetails?.futurePayDate);
  const validityFrom = new Date(queryDataSubdetails?.validityFrom);
  const futurePayDateUTC = new Date(Date.UTC(futurePayDate.getFullYear(), futurePayDate.getMonth(), futurePayDate.getDate()));
  const validityFromUTC = new Date(Date.UTC(validityFrom.getFullYear(), validityFrom.getMonth(), validityFrom.getDate()));
  return queryDataSubdetails?.installmentTypeId == 3 ? 1 : queryDataSubdetails?.installmentTypeId == 4 ? 12 : queryDataSubdetails?.installmentTypeId == 2 ? 7 : Math.round((futurePayDateUTC - validityFromUTC) / (1000 * 60 * 60 * 24))
  },[queryData?.subsDetails?.[0]?.installmentNumber,queryDataSubdetails])


  const installmentTabledataquery = useMemo(() => {
    const futurePayDate = new Date(queryDataSubdetails?.futurePayDate);
    const validityFrom = new Date(queryDataSubdetails?.validityFrom);
    const futurePayDateUTC = new Date(Date.UTC(futurePayDate.getFullYear(), futurePayDate.getMonth(), futurePayDate.getDate()));
    const validityFromUTC = new Date(Date.UTC(validityFrom.getFullYear(), validityFrom.getMonth(), validityFrom.getDate()));
    const unit= (queryDataSubdetails?.installmentTypeId == 3 || queryDataSubdetails?.installmentTypeId == 4) ? "months" : "days";
    const lengthInstallment = queryDataSubdetails?.installmentTypeId == 3 ? 1 : queryDataSubdetails?.installmentTypeId == 4 ? 12 : queryDataSubdetails?.installmentTypeId == 2 ? 7 : Math.round((futurePayDateUTC - validityFromUTC) / (1000 * 60 * 60 * 24))
    // console.log(unit,lengthInstallment,"lengthInstallment",returnStartDate99(unit, queryDataSubdetails?.totalInstallment, queryDataSubdetails?.futurePayDate,2))
  let resultArr = Array.from({ length: queryDataSubdetails?.totalInstallment || 0 }, (_, index) => ({
    amount: queryDataSubdetails?.totalAmount,
    payAmount: queryDataSubdetails?.totalPaid,
    installmentAmount: queryDataSubdetails?.installmentAmount,
    installmentFrequencies: lengthInstallment,
    installmentDate: returnStartDate99(unit, lengthInstallment, queryDataSubdetails?.futurePayDate, index)
  }));

  // console.log(paymentData,"paymentDatainstallmentNumber",resultArr)
  return resultArr
}, [queryData?.subsDetails?.[0]?.installmentNumber,queryDataSubdetails])

  useEffect(()=>{
    const defaultAccountTypeId = isHourlyIOALTA == true ? 2 : 1; // Assuming 1 is the default AccountTypeId
    if(clikedOnPay==true){
      return
    }
    if(PaymentOption == 1 && isNotValidNullUndefile(paymentData?.amount)){
      setPaymentaccount([{AccountTypeId: defaultAccountTypeId, Amount: paymentData?.amount}])
    }
    else if(PaymentOption == 2 && paymentData?.payAmount){
      setPaymentaccount([{AccountTypeId: defaultAccountTypeId, Amount: paymentData?.payAmount}])
    }else{
      setPaymentaccount([])
    }
  },[PaymentOption,paymentData?.amount,paymentData?.payAmount])

  const addnewServicefunc = () => {
    setAddnewservice(true)
    scrollToSection()
  }

return (
  <>
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-md p-6">

        {userRegistration == true && <h3 className="text-lg font-semibold mb-4 ms-0">Registration here</h3>}

        {(config?.demo == true && isClient !== true && (!queryData || (queryData?.paymnetFromIntake !== "true" && queryData?.paymnetFromEventCoordinator !== 'true'))) && <div className="flex gap-4 items-center">
          <h3 className="text-lg font-semibold mb-4 ms-0">Client Lookup</h3>
          <div className="flex items-center mb-2">
            <button
              onClick={() => setTimematter(!timeMatter)}
              className={`relative w-32 h-7 flex items-center rounded-full px-2 transition-colors duration-300 ${timeMatter ? 'bg-green-500' : 'bg-gray-300'
                }`}
            >
              <div
                className={`absolute top-1 w-5 h-5 bg-white rounded-full shadow-md transform transition-transform duration-300 ${timeMatter ? 'translate-x-[92px]' : 'translate-x-0'
                  }`}
              ></div>
              <span
                className={`w-full text-center font-medium text-white text-xs select-none ${timeMatter ? 'pr-7' : 'pl-7 text-[#374751]'
                  }`}
              >
                {timeMatter ? 'Time matters' : 'Test Clients'}
              </span>
            </button>
          </div>
        </div>}
        {((isClient !== true && (!queryData || (queryData?.paymnetFromIntake !== "true" && queryData?.paymnetFromEventCoordinator !== 'true')))) && <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <SearchBar showDropdown={showDropdown} setMatterNumber={setMatterNumber} matterNumber={matterNumber} results={results} setSearchData={setSearchData} runApis={runApis} />
        </div>}
        {(showUserForm == true || userRegistration == true) && <AddNewUser queryData={queryData} selectedUser={selectedUser} setSelecteduser={setSelecteduser} updateUser={updateUser} referencePage={"lpl"} setToast={setToast} subtenantId={subtinentId} timeMatter={timeMatter} setMatterNumber={setMatterNumber} setTimematter={setTimematter} />}
      </div>
      {userRegistration !== true &&
        <>
        {(!queryData || (queryData?.paymnetFromIntake !== "true" && queryData?.paymnetFromEventCoordinator !== 'true')) && (
          <div className="bg-white rounded-lg shadow-md p-6 w-100" >
            <div className="flex justify-between w-100">
            <h3 className="text-lg font-semibold mb-4">{issplitPayment == true ? 'Service:' : `Services availed by ${isClient !== true ? 'client' : 'you'} till date:`}</h3>
            {/* <button className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300 transition mb-2" onClick={()=>{addnewServicefunc()}}>Add New Service</button> */}
            </div>
            {selectedUser?.clientAuthSubsVMs?.length > 0 ? <table className="w-full table border rounded-[5px] a1">
              <thead>
                <tr style={headerStyleTop}>
                  {serviceHead?.map((e) => (<th style={headerStyleTop} className={`${(e=="Due Date")?"dflexCol":""}`}><span>{e}</span></th>))}
                  {/* dflexCol */}
                </tr>
              </thead>
              <tbody>
                {/* {console.log("serviceserviceserviceservice2",selectedUser?.clientAuthSubsVMs,'issplitPayment',issplitPayment)} */}
                {(issplitPayment == true ? [...selectedUser?.clientAuthSubsVMs?.filter((f)=> f?.userAuthSubId == splitsessiondata?.userAuthSubId)] : [...selectedUser?.clientAuthSubsVMs])?.sort((a, b) => new Date(a?.authSubsStartDate) - new Date(b?.authSubsStartDate))?.map((service) => {
                  // console.log(service,"serviceserviceserviceservice",selectedUser?.clientAuthSubsVMs,'issplitPayment',issplitPayment)
                  let totalPaid = service.clientAuthInsVMs?.filter((r)=> r.isRefund != true)?.reduce((a, c) => { return a + c.payAmount }, 0)
                  let refundedArray = service?.clientAuthInsVMs?.filter((r)=> r.isRefund == true)
                  let refunedAmount = refundedArray?.reduce((a, c) => a + (Number(c.payAmount) || 0), 0) ?? 0;
                  let pendingAmount = service?.totalAmount?.toFixed(2) - (service?.totalDiscount || 0)?.toFixed(2) - totalPaid?.toFixed(2);
                  // console.log("42ewfdc",service)
                  return <tr className="w-100" style={cellStyle}>
                    <td style={cellStyle}>{service?.subscriptionName}</td>
                    {/* <td style={cellStyle}>{formatDateLocal(service?.authSubsStartDate)}</td> */}
                    <td style={cellStyle}>{formatDateLocal(service?.authSubsStartDate)}</td>
                    <td style={cellStyle}>${formatToUS(service?.totalAmount?.toFixed(2))}</td>
                    <td style={cellStyle}>${formatToUS((service?.totalDiscount || 0)?.toFixed(2))}</td>
                    <td style={cellStyle}>${formatToUS(totalPaid?.toFixed(2))}</td>
                    <td style={cellStyle}>${formatToUS(pendingAmount?.toFixed(2)) || 0}</td>
                    <td style={cellStyle} className="text-[red]">${formatToUS(refunedAmount?.toFixed(2)) || 0}</td>
                    <td><div className="flex items-center">{
                      pendingAmount <= 0 ? <p>Completed</p> :
                                                  (service.authSubscriptionId != null && service?.isCancelSubscription!=true) ? <div><p>Scheduled </p><p className="text-[12px]">Date: {formatDateIntoDDMMYY(service?.installmentStartDate)}</p></div>
                                                                                       : (!(splitsessiondata?.userId) ?
                                                                                                    <button className="px-2 py-1 bg-green-500 text-white rounded-md hover:bg-green-600 ms-2 my-2" onClick={() => payServicefunc(service, pendingAmount,undefined,'Pay')}>Pay</button>
                                                                                                    : '-')
                    }
                    {(isClient !== true && !(splitsessiondata?.userId) && pendingAmount > 0 && !(service?.authSubscriptionId != null && service?.isCancelSubscription != true)) && <button className="px-2 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 ms-2 my-2" onClick={() => deleteServicefunc(service)}>Delete</button>}
                    </div></td>

                    <td style={cellStyle}>{service?.matterStatus}</td>
                  </tr>
                })}
              </tbody>
            </table> : 'No records'}
          </div>
        )}
          {/* Service Selection */}
          <div ref={servicetyperef}>
          {<div className="bg-white rounded-lg shadow-md p-6" >
            <div className="flex w-100 justify-between align-center">
              <h3 className="text-lg font-semibold mb-4">New -Service Type- Billed For <span className="text-red-600">*</span></h3>
              {(selectedUser?.clientAuthSubsVMs?.length > 0 && !isNullUndefine(paymentData.userAuthSubId) && (!queryData || (queryData?.paymnetFromIntake !== "true" && queryData?.paymnetFromEventCoordinator !== 'true'))) && !(splitsessiondata?.userId) && <button className="px-4 py-1 bg-gray-500 text-white rounded-md hover:bg-gray-600 mb-2" onClick={() => resetToLifepaointdata()}>Reset</button>}
            </div>
            {/* <select
              className={`pl-2 pr-4 py-2 w-full border border-gray-300 rounded-md ${queryData?.paymnetFromIntake === "true" ? 'bg-gray-200 cursor-not-allowed' : isNotValidNullUndefile(paymentData.userAuthSubId) ? 'bg-gray-200' : 'bg-white'}`}
              value={paymentData.lineOfBusiness}
              onChange={(e) => handleInputChange('lineOfBusiness', e)}
              disabled={isNotValidNullUndefile(paymentData.userAuthSubId) ? true : isServiceLocked ? true : false}
            >
              <option value="">Select Service Type</option>
              {isValidFuntion(service) && Object?.entries(service)?.map(([id, ele]) => (
                <option key={id} name={ele?.subscriptionName} value={ele?.subscriptionId}>{ele?.subscriptionName}</option>
              ))}
            </select> */}
            <SearchableSelect
                      // label="New -Service Type- Billed For"
                      value={paymentData.lineOfBusiness}
                      options={service}
                      optionLabel={(o) => o.subscriptionName}
                      optionValue={(o) => o.subscriptionId}
                      onChange={(value) => handleInputChange('lineOfBusiness', value)}
                      disabled={isNotValidNullUndefile(paymentData.userAuthSubId) ? true : isServiceLocked ? true : false}
                      placeholder={`Select Service Type`}
                      beforeOpen={handleBeforeOpen}
                    />
            {paymentData.lineOfBusiness == 9 && <>
              <div className="flex w-100 justify-between align-center">
                <h3 className="text-lg font-semibold mb-2">Description</h3>
              </div>
              <input
                type="text"
                className="pl-3 pr-4 py-2 w-full border border-gray-300 rounded-md"
                placeholder='Enter Description'
                value={paymentData?.subscriptionName || ''}
                onChange={(e) => handleInputChange('subscriptionName', e.target.value)}
              />
            </>
            }
            <div className="flex w-full justify-between gap-3">
            <div className="w-1/2">
            <h3 className="text-lg font-semibold mb-4 mt-2">Matter Number</h3>
            <input
              type="text"
              className="pl-4 pr-4 py-2 w-full border border-gray-300 rounded-md"
              placeholder='Enter Matter Number'
              value={(paymentData?.serviceMatNo) || ''}
              onChange={(e) => handleInputChange('serviceMatNo', e.target.value)}
              onFocus={async (e) => !(await handleBeforeOpen()) && e.target.blur()}
            />
            </div>
            <div className="w-1/2">
            <h3 className="text-lg font-semibold mb-4 mt-2" >Source Type</h3>
            <SearchableSelect
            value={paymentData?.sourceType?.toString()}
            options={sourceType}
            onChange={(value)=> handleInputChange("sourceType", value)}
            disabled={isNotValidNullUndefile(paymentData.userAuthSubId) ? true : false}
            placeholder='Select source type '
            />
            {paymentData.sourceType == "999999" && <>
            {/* <div className="flex w-100 justify-between align-center">
              <h3 className="text-lg font-semibold mb-2">Description</h3>
            </div> */}
            {/* <input
                type="text"
                className="pl-3 pr-4 py-2 w-full border border-gray-300 rounded-md"
                placeholder='Enter Description'
                value={paymentData?.sourceTypeother || ''}
                onChange={(e) => handleInputChange('sourceTypeother', e.target.value)}
              /> */}
              <OtherInput othersCategoryId={40} userId={selectedUser.userId} natureId={paymentData?.userAuthSubId} dropValue="999999" ref={otherSourceref} disabled={isNotValidNullUndefile(paymentData.userAuthSubId) ? true : false} />
            </>}
            </div>
            </div>
          </div>}
          </div>
          {console.log(paymentData,"paymentdataselectedUserData",selectedUser)}
          {/* Compensation Rules */}
          {isClient !== true && <div className="bg-white rounded-lg shadow-md p-6">
            <div className='flex justify-between'>
              <h3 className="text-lg font-semibold mb-4">Staff Assignment</h3>
              {(queryData?.paymnetFromIntake != 'true' && queryData?.paymnetFromEventCoordinator !== 'true') && config?.isLogin == false && <button onClick={() => setIsOpen(true)} className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition">Add Staff</button>}
              {/* {queryData?.paymnetFromIntake !== "true" && <button onClick={() => setIsOpen(true)} className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition">Add Staff</button>} */}
            </div>
            {(!isAMAService) ? (
              // Regular Service Compensation
              <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    {/* <label className="block text-sm font-medium text-gray-700 mb-1">
                      Originating {paymentData?.lineOfBusiness == 1 ? 'Staff Member' : 'Staff'}
                    </label>
                    <select
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md ${queryData?.paymnetFromIntake === "true" ? 'bg-gray-200 cursor-not-allowed' : ''}`}
                      value={paymentData.originatingAttorney || ''}
                      onChange={(e) => handleInputChange('originatingAttorney', e.target.value)}
                      disabled={isServiceLocked ? true : false}
                    >
                      <option value="">Select Originating {paymentData?.lineOfBusiness == 1 ? 'Staff Member' : 'Staff'}</option>
                      {isValidFuntion(originating) &&
                       originating?.map(attorney => (
                        <option key={attorney.userId} value={attorney.userId}>{formatName(attorney.fullName)}</option>
                      ))}
                    </select> */}
                    {/* {console.log(paymentData.originatingAttorney,"paymentDataoriginatingAttorney")} */}
                    <SearchableSelect
                      label="Originating Staff"
                      value={paymentData.originatingAttorney}
                      options={originating}
                      optionLabel={(o) => formatName(o.fullName)}
                      optionValue={(o) => o.userId}
                      onChange={(value) => handleInputChange("originatingAttorney", value)}
                      disabled={isServiceLocked ? true : false}
                      placeholder={`Select Originating ${paymentData?.lineOfBusiness == 1 ? "Staff Member" : "Staff"}`}
                      beforeOpen={handleBeforeOpen}
                    />


                  </div>
                  {/* <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Origination Percentage
                </label>
                <div className="relative">
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="0.5"
                    className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-md"
                    value={paymentData.originationPercentage || ''}
                    onChange={(e) => handleInputChange('originationPercentage', limitPercentage(e.target.value) || 0)}
                  />
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <span className="text-gray-500">%</span>
                  </div>
                </div>
              </div> */}
                </div>
                {/* {console.log(paymentData,"paymentData",reponsible,"reponsible",originating,"originating")} */}
                {<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    {/* <label className="block text-sm font-medium text-gray-700 mb-1">
                      Responsible Attorney
                    </label> */}
                    {/* <select
                      className={`w-full px-3 py-2 border border-gray-300 rounded-md ${queryData?.paymnetFromIntake === "true" ? 'bg-gray-200 cursor-not-allowed' : ''}`}
                      value={paymentData.responsibleAttorney || ''}
                      onChange={(e) => handleInputChange('responsibleAttorney', e.target.value)}
                      disabled={isServiceLocked ? true : false}
                    >
                      <option value="">Select Responsible Attorney</option>
                      {isValidFuntion(reponsible) && reponsible?.map(attorney => (
                        <option key={attorney.userId} value={attorney.userId}>{formatName(attorney.fullName)}</option>
                      ))}
                    </select> */}
                   {queryData?.paymnetFromEventCoordinator !== 'true' && <SearchableSelect
                      label="Responsible Attorney"
                      value={paymentData.responsibleAttorney}
                      options={reponsible}
                      optionLabel={(o) => formatName(o.fullName)}
                      optionValue={(o) => o.userId}
                      onChange={(value) => handleInputChange("responsibleAttorney", value)}
                      disabled={isServiceLocked ? true : false}
                      placeholder={`Select Responsible Attorney`}
                      beforeOpen={handleBeforeOpen}
                    />}
                  </div>
                  {/* <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Responsible Percentage
                </label>
                <div className="relative">
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="0.5"
                    className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-md"
                    value={paymentData.responsiblePercentage || ''}
                    onChange={(e) => handleInputChange('responsiblePercentage', limitPercentage(e.target.value) || 0)}
                  />
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <span className="text-gray-500">%</span>
                  </div>
                </div>
              </div> */}
                </div>}

                {/* Compensation Summary */}
                {paymentData.amount > 0 && (paymentData.originationPercentage > 0 || paymentData.responsiblePercentage > 0) && (
                  <div className="mt-4 p-4 bg-blue-50 rounded-md">
                    <h4 className="font-medium mb-2">Compensation Summary</h4>
                    {paymentData.originationPercentage > 0 && paymentData.originatingAttorney && (
                      <div className="flex justify-between">
                        <span>Originating ({originating?.find(a => a.userId === paymentData.originatingAttorney)?.fullName}):</span>
                        <span>${((paymentData.amount * paymentData.originationPercentage) / 100).toFixed(2)}</span>
                      </div>
                    )}
                    {paymentData.responsiblePercentage > 0 && paymentData.responsibleAttorney && (
                      <div className="flex justify-between">
                        <span>Responsible ({reponsible?.find(a => a.userId === paymentData.responsibleAttorney)?.fullName}):</span>
                        <span>${((paymentData.amount * paymentData.responsiblePercentage) / 100).toFixed(2)}</span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              // AMA Compensation
              <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Selling Attorney/Staff
                    </label>
                    <select
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      value={paymentData.sellingPerson || ''}
                      onChange={(e) => handleInputChange('sellingPerson', e.target.value)}
                    >
                      <option value="">Select Selling Person</option>
                      {attorneys?.filter(a => a.id !== 'none')?.map(attorney => (
                        <option key={attorney.id} value={attorney.id}>{attorney.name}</option>
                      ))}
                      <option value="staff_member_1">Staff Member 1</option>
                      <option value="staff_member_2">Staff Member 2</option>
                      <option value="staff_member_3">Staff Member 3</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Commission Percentage
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        min="0"
                        max="100"
                        step="0.5"
                        className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-md"
                        value={paymentData.commissionPercentage || ''}
                        onChange={(e) => handleInputChange('commissionPercentage', limitPercentage(e.target.value) || 0)}
                      />
                      <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                        <span className="text-gray-500">%</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* AMA Commission Summary */}
                {paymentData.amount > 0 && paymentData.commissionPercentage > 0 && paymentData.sellingPerson && (
                  <div className="mt-4 p-4 bg-green-50 rounded-md">
                    <h4 className="font-medium mb-2">AMA Commission Summary</h4>
                    <div className="flex justify-between">
                      <span>Commission ({paymentData.sellingPerson.includes('staff') ? 'Staff Member' : attorneys?.find(a => a.id === paymentData.sellingPerson)?.name}):</span>
                      <span>${((paymentData.amount * paymentData.commissionPercentage) / 100).toFixed(2)}</span>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>}
          {(isNullUndefine(paymentData.userAuthSubId) && (!queryData || (queryData?.paymnetFromIntake !== "true" && queryData?.paymnetFromEventCoordinator !== 'true'))) && <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-lg font-semibold mb-4" >Payment Option</h3>
            <div className="relative flex gap-2">
              {radioButton('Full Payment', '1', PaymentOption, setPaymentoption)}
              {radioButton('Installment', '2', PaymentOption, setPaymentoption)}
            </div>
          </div>}
          {/* Amount */}
          {/* {console.log(paymentData.userAuthSubId,"checkcondtion",!(splitsessiondata?.userId),"paymentData",paymentData,"PaymentOption",PaymentOption)} */}
          {paymentData.userAuthSubId && !(splitsessiondata?.userId) ? <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-lg font-semibold mb-4">Payment Amount<span className="text-red-600">*</span></h3>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-gray-500">$</span>
              </div>
              <input
                type="text"
                // min="0"
                // step="1"
                className={`pl-7 pr-4 py-2 w-full border border-gray-300 rounded-md ${(queryData?.paymnetFromIntake === "true" || queryData?.paymnetFromEventCoordinator == 'true') ? 'bg-gray-200 cursor-not-allowed' : ''}`}
                placeholder='0'
                value={formatToUS(paymentData.payAmount) || ''}
                onChange={(e) => handleInputChange('payAmount', (e.target.value))}
                onFocus={async (e) => !(await handleBeforeOpen()) && e.target.blur()}
              />
            </div>
          </div> : PaymentOption == 1 ? <div className="bg-white rounded-lg shadow-md p-6">
            {queryData?.subsDetails?.[0]?.isInstallmentPlan == true ? ''
            // <h3>Total Amount*</h3>
             :<h3 className="text-lg font-semibold mb-4">Payment Amount <span className="text-red-600">*</span></h3>}
            {queryData?.subsDetails?.[0]?.isInstallmentPlan == true ?
            // <div className="relative">
            //   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            //     <span className="text-gray-500">$</span>
            //   </div>
            //   <input type="text" className={` w-1/4 pl-7 pr-4 py-2 w-full border border-gray-300 rounded-md ${queryData?.paymnetFromIntake === "true" ? 'bg-gray-200 cursor-not-allowed' : ''}`} value={queryDataSubdetails?.totalAmount} /> </div>
              '' :<div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-gray-500">$</span>
              </div>
              <input
                type="text"
                // min="0"
                // step="1"
                className={`pl-7 pr-4 py-2 w-full border border-gray-300 rounded-md ${(queryData?.paymnetFromIntake === "true" || queryData?.paymnetFromEventCoordinator == 'true') ? 'bg-gray-200 cursor-not-allowed' : ''}`}
                placeholder='0'
                // maxLength={20}
                value={formatToUS(queryData?.paymnetFromEventCoordinator == 'true' ? (queryData?.totalCost) : paymentData?.amount) || ''}
                onChange={(e) => handleInputChange('amount', e.target.value)}
                disabled={isServiceLocked ? true : false}
                onFocus={async (e) => !(await handleBeforeOpen()) && e.target.blur()}
              />
            </div>}
            {console.log(queryData,"queryDataSubdetails",queryDataSubdetails)}
          {(queryData?.paymnetFromIntake == 'true' || queryData?.paymnetFromEventCoordinator == 'true') && <div>
            {queryData?.subsDetails?.[0]?.isInstallmentPlan == true ? <>
            <div className="flex w-full gap-2 mt-2">
                  <div className="w-1/3">
                    <h3 className="block text-sm font-medium text-gray-700 mb-1">Initial Payment*</h3>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <span className="text-gray-500">$</span>
                      </div>
                      <input
                        type="text"
                        min="0"
                        step="1"
                        className="pl-7 pr-4 py-2 w-full border border-gray-300 rounded-md bg-gray-200"
                        placeholder='0'
                        disabled
                        value={(queryData?.clientOrderDetails?.totalCost) || ''}
                        // onChange={(e) => handleInputChange('payAmount', e.target.value)}
                        // onFocus={async (e) => !(await handleBeforeOpen()) && e.target.blur()}
                      />
                    </div>
                  </div>
                  {/* How many installments */}
                  <div className="w-1/3">
                    <h3 className="block text-sm font-medium text-gray-700 mb-1">How many installments*</h3>
                    <input className="pl-3 pr-2 py-2 w-full border border-gray-300 rounded-md bg-gray-200" placeholder="Enter installments"  disabled={true} value={queryDataSubdetails?.totalInstallment} />
                  </div>
                  {/* {paymentData?.installmentFrequencies > 0 && removeCommas(paymentData?.amount) > 0 && paymentData?.installmentNumber > 0 &&  */}
                  <div className="w-1/3">
                    <h3 className="block text-sm font-medium text-gray-700 mb-1">Installment Amount*</h3>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none bg-gray-200 rounded-md">
                        <span className="text-gray-500">$</span>
                      </div>
                      <input
                        type="text"
                        className={`pl-7 pr-4 py-2 w-full border border-gray-300 rounded-md bg-gray-200`}
                        placeholder='0'
                        // value={formatToUS(installmentAmount?.toFixed(2)) || ''}
                        disabled
                        value={queryDataSubdetails?.installmentAmount}
                        // onChange={(e) => handleInputChange('installmentAmount', !isNaN((e.target.value)) ? (e.target.value) : 0)}
                        // onFocus={async (e) => !(await handleBeforeOpen()) && e.target.blur()}
                      />
                    </div>
                  </div>
                  {/* } */}
                  {/* Installment Frequencies* */}
                  <div className="w-1/3">
                    <h3 className="block text-sm font-medium text-gray-700 mb-1">Installment Frequencies*</h3>
                    <div className="relative">
                      <select className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-300"
                      // value={paymentData?.installmentFrequencies ?? '-1'}
                      value={lengthInstallment || '1'}
                      //  onChange={(e) => handleInputChange('installmentFrequencies', e.target.value)}
                      disabled
                       >
                        <option value="-1" disabled>Select</option>
                        {notifyTypearray?.map((freq) => (
                          <option value={freq.value}>{freq.label}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="w-1/3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Select Installment Date*
                    </label>
                    <input
                      type="date"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-200"
                      disabled
                      value={formatDate(queryDataSubdetails?.futurePayDate)}
                      // value={paymentData?.installmentDate}
                      // onChange={(e) => handleInputChange('installmentDate', e.target.value)}
                      // min={getTomorrowDate()}
                      // onBlur={handleInstallmentDateBlur}
                    />
                  </div>
                </div>
                {console.log(installmentTabledataquery,"installmentTabledataquery")}
                {installmentTabledataquery?.length > 0 && <div className="flex w-full gap-2 mt-4">
              <table className="w-full table border rounded-[5px] a2">
                <thead>
                  <tr style={headerStyle}>
                    {serviceHead2?.map((e) => (<th style={headerStyle}>{e}</th>))}
                  </tr>
                </thead>
                <tbody>
                  {installmentTabledataquery?.map((e, index) => <tr className="w-100" style={cellStyle}>
                    <td style={cellStyle}>${(e?.amount) || '0.00'}</td>
                    <td style={cellStyle}>${(e?.payAmount) || '0.00'}</td>
                    {/* <td style={cellStyle}>{e?.installmentNumber || '-'}</td> */}
                    <td style={cellStyle}>${(e?.installmentAmount)?.toFixed(2) || (installmentAmount)?.toFixed(2) || '0.00'}</td>
                    <td style={cellStyle}>{e?.installmentFrequencies < 0 ? '-' : notifyTypearray?.filter((ele) => { return ele.value == e?.installmentFrequencies })[0]?.label}</td>
                    <td style={cellStyle}>{!isNotValidNullUndefile(e?.installmentDate) || e?.installmentDate == 'Invalid Date' ? '-' : (formatDateIntoUS(e?.installmentDate)) || '-'}</td>
                  </tr>)}
                </tbody>
              </table>
            </div>}
            </> : <>{queryData && queryData?.subscriptionType != "AMA&Fee" && queryData?.subsDetails?.length > 0 && queryData?.subsDetails?.[0]?.isInstallmentPlan == true && <p className="mt-2">Installment Amount: ${paymentData?.totalAmount}</p>}
              {queryData && queryData?.subscriptionType == "onlyAMA" && <p className="mt-2">Installment Amount: ${isNotValidNullUndefileInstallmentAmount(queryData?.installmentRenew) ? queryData?.installmentRenew : (queryData?.clientOrderDetails?.productList?.[0]?.totalProductPrice || paymentData?.amount)}</p>}
              {queryData && queryData?.subsDetails?.length > 0 && isNotValidNullUndefile(queryData?.subsDetails?.[0]?.installmentAmount) && queryData?.subsDetails?.[0]?.installmentAmount != 0 && <p className="mt-2">Installment Amount: ${queryData?.subsDetails?.[0]?.installmentAmount}</p>}
              {queryData && queryData?.subscriptionType == "AMA&Fee" && isNotValidNullUndefileInstallmentAmount(queryData?.installmentAmountAMA) && <p className="mt-2">Installment Amount AMA: ${queryData?.installmentAmountAMA}</p>}
              </>}
            </div>}
          </div> : <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-lg font-semibold mb-2">Installment Setup</h3>
            <div className="relative">

              <div className="mt-2">
                <h3 className="block text-sm font-medium text-gray-700 mb-1">Total Amount*</h3>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <span className="text-gray-500">$</span>
                  </div>
                  <input
                    type="text"
                    min="0"
                    step="1"
                    className="pl-7 pr-4 py-2 w-1/3 border border-gray-300 rounded-md"
                    placeholder='0'
                    value={formatToUS(paymentData.amount) || ''}
                    // onChange={(e) => handleInputChange('amount', !isNaN(parseFloat(e.target.value)) ? parseFloat(e.target.value) : 0)}
                    onChange={(e) => handleInputChange('amount', e.target.value)}
                    onFocus={async (e) => !(await handleBeforeOpen()) && e.target.blur()}
                  />
                </div>
                <div className="flex w-full gap-2 mt-2">
                  <div className="w-1/3">
                    <h3 className="block text-sm font-medium text-gray-700 mb-1">Initial Payment*</h3>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <span className="text-gray-500">$</span>
                      </div>
                      <input
                        type="text"
                        min="0"
                        step="1"
                        className="pl-7 pr-4 py-2 w-full border border-gray-300 rounded-md"
                        placeholder='0'
                        value={formatToUS(paymentData.payAmount) || ''}
                        onChange={(e) => handleInputChange('payAmount', e.target.value)}
                        onFocus={async (e) => !(await handleBeforeOpen()) && e.target.blur()}
                      />
                    </div>
                  </div>
                  {/* How many installments */}
                  <div className="w-1/3">
                    <h3 className="block text-sm font-medium text-gray-700 mb-1">How many installments*</h3>
                    <input className="pl-3 pr-2 py-2 w-full border border-gray-300 rounded-md" placeholder="Enter installments" value={paymentData?.installmentNumber} onChange={(e) => handleInputChange('installmentNumber', e.target.value)} disabled={paymentData?.installmentFrequencies == 4 && true} />
                  </div>
                  {/* {paymentData?.installmentFrequencies > 0 && removeCommas(paymentData?.amount) > 0 && paymentData?.installmentNumber > 0 &&  */}
                  <div className="w-1/3">
                    <h3 className="block text-sm font-medium text-gray-700 mb-1">Installment Amount*</h3>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <span className="text-gray-500">$</span>
                      </div>
                      <input
                        type="text"
                        className={`pl-7 pr-4 py-2 w-full border border-gray-300 rounded-md bg-gray-200`}
                        placeholder='0'
                        value={formatToUS(installmentAmount?.toFixed(2)) || ''}
                        disabled
                        onChange={(e) => handleInputChange('installmentAmount', !isNaN((e.target.value)) ? (e.target.value) : 0)}
                        onFocus={async (e) => !(await handleBeforeOpen()) && e.target.blur()}
                      />
                    </div>
                  </div>
                  {/* } */}
                  {/* Installment Frequencies* */}
                  <div className="w-1/3">
                    <h3 className="block text-sm font-medium text-gray-700 mb-1">Installment Frequencies*</h3>
                    <div className="relative">
                      <select className="w-full px-3 py-2 border border-gray-300 rounded-md" value={paymentData?.installmentFrequencies ?? '-1'} onChange={(e) => handleInputChange('installmentFrequencies', e.target.value)}>
                        <option value="-1" disabled>Select</option>
                        {notifyTypearray?.map((freq) => (
                          <option value={freq.value}>{freq.label}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="w-1/3">
                  {console.log(paymentData?.installmentDate,"paymentDatainstallmentDate")}
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Select Installment Date*
                    </label>
                    <input
                      type="date"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      value={paymentData?.installmentDate}
                      onChange={(e) => handleInputChange('installmentDate', e.target.value)}
                      min={getTomorrowDate()}
                      onBlur={handleInstallmentDateBlur}
                    />
                  </div>
                </div>
                {/* Installment Amount* */}
                {paymentData?.installmentFrequencies > 0 && <div className="flex w-full gap-2 mt-3">
                  {/* {removeCommas(paymentData?.amount) > 0 && paymentData?.installmentNumber > 0 && <div className="w-1/3">
            <h3 className="block text-sm font-medium text-gray-700 mb-1">Installment Amount*</h3>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-gray-500">$</span>
              </div>
              <input
                type="text"
                className="pl-7 pr-4 py-2 w-full border border-gray-300 rounded-md"
                placeholder='0'
                value={formatToUS(installmentAmount?.toFixed(2)) || ''}
                disabled
                onChange={(e) => handleInputChange('installmentAmount', !isNaN((e.target.value)) ? (e.target.value) : 0)}
              />
            </div>
            </div>} */}
                  {/* Select Installment Date */}
                  {/* <div className="w-1/3">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Select Installment Date*
              </label>
              <input
                type="date"
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                value={paymentData?.installmentDate}
                onChange={(e) => handleInputChange('installmentDate', e.target.value)}
                min={getTomorrowDate()}
                onBlur={handleInstallmentDateBlur}
              />
            </div> */}
                  <div>
                  </div>
                </div>}
                <div>
                </div>
              </div>
            </div>
            {installmentTabledata?.length > 0 && <div className="flex w-full gap-2 mt-4">
              <table className="w-full table border rounded-[5px] a3">
                <thead>
                  <tr style={headerStyle}>
                    {serviceHead2?.map((e) => (<th style={headerStyle}>{e}</th>))}
                  </tr>
                </thead>
                <tbody>
                  {installmentTabledata?.map((e, index) => <tr className="w-100" style={cellStyle}>
                    <td style={cellStyle}>${formatToUS(e?.amount) || '0.00'}</td>
                    <td style={cellStyle}>${formatToUS(e?.payAmount) || '0.00'}</td>
                    {/* <td style={cellStyle}>{e?.installmentNumber || '-'}</td> */}
                    <td style={cellStyle}>${(e?.installmentAmount)?.toFixed(2) || (installmentAmount)?.toFixed(2) || '0.00'}</td>
                    <td style={cellStyle}>{e?.installmentFrequencies < 0 ? '-' : notifyTypearray?.filter((ele) => { return ele.value == e?.installmentFrequencies })[0]?.label}</td>
                    <td style={cellStyle}>{!isNotValidNullUndefile(e?.installmentDate) || e?.installmentDate == 'Invalid Date' ? '-' : (formatDateIntoUS(e?.installmentDate)) || '-'}</td>
                  </tr>)}
                </tbody>
              </table>
            </div>}
          </div>}

          {isNullUndefine(paymentData.userAuthSubId) && <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-lg font-semibold mb-4">Note</h2>
            <textarea className="pl-2 py-2 w-full border border-gray-300 rounded-md" placeholder='Enter note here ...' value={paymentData?.notes} onChange={(e) => handleInputChange('notes', e.target.value)} />
          </div>}

          <Paymentform handleBeforeOpen={handleBeforeOpen} showSplitpayment={true} setPaymentData={setPaymentData} paymentData={paymentData} PaymentOption={PaymentOption} installmentpay={installmentpay} splitPaymentno={splitPaymentno} setSplitPaymentno={setSplitPaymentno} queryData={queryData} />
          {/* {splitPaymentno == 'Yes' ? <></> :(!paymentData?.splitAmount && isClient !== true) && <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="block text-sm font-medium text-gray-700 mb-1">This payment will go to?</h2>
            <div className="relative flex gap-6">
              {chackboxButton('General Account', 1, paymentAccount, setPaymentaccount)}
              {chackboxButton('IOLTA Account', 2, paymentAccount, setPaymentaccount)}
            </div>
          </div>} */}

        </>
      }
    </div>
    {isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
        {/* Modal Box */}
        <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-2xl shadow-lg w-full max-w-3xl max-h-[100vh] relative flex flex-col">
          {/* Header */}
          <div className="flex justify-between items-center border-b px-4 py-2">
            <h2 className="text-xl font-semibold">Add Staff</h2>
            <button onClick={() => setIsOpen(false)} className="text-gray-500 hover:text-gray-700">✕</button>
          </div>

          {/* Content (scrolls together with header/footer) */}
          {config?.isLogin == false && <div className="p-4">
            <AddStaff getUserListData={getUserListData} setIsOpen={setIsOpen} setuseLoader={setuseLoader} />
          </div>}


        </div>
      </div>
    )}
    {(showConfirm && queryData?.paymnetFromIntake !== "true" && queryData?.paymnetFromEventCoordinator !== 'true') && (
      <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
          <h2 className="text-xl font-semibold text-gray-800">Confirm Save</h2>
          <p className="mt-3 text-gray-600">
            Would you like to save before continuing?
          </p>
          <div className="mt-6 flex justify-end gap-3">
            <button onClick={handleSave} className="px-4 py-2 rounded-lg bg-green-600 text-white">
              Save
            </button>
            <button onClick={handleDiscard} className="px-4 py-2 rounded-lg bg-green-600 text-white">
              Cancel
            </button>
          </div>
        </div>
      </div>
    )}
  </>
);
}

export default LifepointLaw;